(function(){
  var logo_Swiper = new Swiper(".dairy__logo-Slider", {
      slidesPerView: 1,
      spaceBetween: 10,
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
    });
  logo_Swiper.on("slideChange",function(e){
    const previousSlide = document.querySelector(".dairy__logo-Slider .swiper-slide-active .logo-bar__item");
    previousSlide.classList.remove('active');
    setTimeout(function(){
      const currentSlide = document.querySelector(".dairy__logo-Slider .swiper-slide-active .logo-bar__item");
      const id = currentSlide.getAttribute("data-id");
      currentSlide.classList.add("active");
      document.querySelector(".Dairy-logo-list .logo-list-description:not(.hidden)").classList.add("hidden");
      document.querySelector(".Dairy-logo-list #"+id)?.classList.remove('hidden');
    },100);
  })

  /*****PRODUCT PAGE ACCORDIONS FUNCTIONALITY****/

  const accordionTriggers = document.querySelectorAll(".product .product__info-container accordion-tab.product__accordion");
  if(accordionTriggers.length > 0){
    accordionTriggers.forEach(function(e){
      e.addEventListener("click",function(){
        accordionTriggers.forEach(function(e){
          e.querySelector("details").removeAttribute("open");
        })
        this.querySelector("details").setAttribute("open",true);
      })
    })
  }

  /*****HEADER HEIGHT CALCULATION****/
  const myHeader = document.querySelector(".shopify-section-group-header-group.shopify-section-header");
  const myAnnoucement = document.querySelector(".shopify-section-group-header-group.shopify-section-announcement-bar");
  let headerHeight = 0;
  if(myHeader){
    headerHeight += Number(myHeader.offsetHeight);
    document.documentElement.style.setProperty('--only-header-height', headerHeight+'px');
    
    if(myAnnoucement){
      headerHeight += Number(myAnnoucement.offsetHeight);
    }
  }
  function setBodyProperty(Pvalue){
    document.documentElement.style.setProperty('--heading-height', Pvalue+'px');
  }
  if(headerHeight){
    setBodyProperty(headerHeight);
  }else{setBodyProperty(0);}

  /******Navigation menu functionality****/
  if(window.innerWidth >= 750){
    const allList = document.querySelectorAll(".header--off-canvas .dairy_drawer_navigation .menu-drawer__menu.list-menu details[data-id]");
    if(allList.length > 0){
      function offset(el) {
        var rect = el.getBoundingClientRect(),
        scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
      }
      allList.forEach(function(e){
        e.addEventListener("click",function(el){
          const divOffset = offset(this);
          const elementTop = divOffset.top;
          const data_id = this.getAttribute("data-id");
          if(document.querySelector(".dairy-new-nav-links .menu-drawer__menu[data-id='"+data_id+"']").classList.contains("active")){
            document.querySelector(".dairy-new-nav-links .menu-drawer__menu.active")?.classList.remove("active");
          }else{
            document.querySelector(".dairy-new-nav-links .menu-drawer__menu.active")?.classList.remove("active");
            document.querySelector(".dairy-new-nav-links .menu-drawer__menu[data-id='"+data_id+"']").style.top = (elementTop - 1)+"px";
            document.querySelector(".dairy-new-nav-links .menu-drawer__menu[data-id='"+data_id+"']").classList.add("active");
          }
        })
      })
    }
  }

  /********HORIZONTAL SCROLLING FUCNTIONALTIY FOR CARD PRODUCTS*********/
window.addEventListener("load",function(){
  var productCardVariants = new Swiper(".card_product-variant-wrapper",{
      spaceBetween: 20,
      slidesPerView: 'auto',
      centerInsufficientSlides: true,
      a11y: false,
      freeMode: true,
      mousewheel: {
        invert: false,
      },
  })
})
})();